import { TRPCRootRouter } from '@athena/server/src/trpc/index';
import { createTRPCReact, CreateTRPCReact } from '@trpc/react-query';

export const trpc: CreateTRPCReact<TRPCRootRouter, unknown, null> = createTRPCReact<TRPCRootRouter>();